import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp.scss';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
      'PdpGalleryComponent',
      'SizeSelectorComponent',
      'AddToCartComponent',
      'NotifyMeComponent',
      'SizeGuidePdpComponent',
      'SizeTableComponent',
      'SizeTableGroupComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'NotifyProductUnavailableComponent',
      'PdpExtendedComponent',
      'PdpGiftCardComponent',
      'VideoBrightcoveComponent'
    ];
  }
}
